export default __webpack_public_path__ + "static/media/login-bg-7.bf02a09a.jpg";